export default __webpack_public_path__ + "static/Laya-c0acaf7d5cd91d922d63b13f1b385dec.png";